<template>
  <div class="header">
    <div>
      <a href="/about" class="link">About</a>
    </div>
    <a href="/" class="logo">
      <svg viewBox="0 0 30 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor">
          <path
            d="M19.955 10.446v1.608h4.286v.937h-4.286v1.607h4.286v.938h-5.357V9.509h5.357v.937h-4.286zM21.563 0c.401 0 .67.402.67.804 0 1.071-.938 1.74-.938 1.74l-.402-.401s.268-.268.402-.804c-.268-.134-.536-.401-.536-.67.134-.401.402-.669.803-.669zM4.955 2.545h1.072v4.553h2.678V8.17h-3.75V2.545zM24.643 6.563c0-.402-.536-.67-1.607-.67-1.741 0-2.545-.536-2.545-1.607 0-1.206.938-1.741 2.545-1.741s2.544.67 2.544 1.74H24.51c0-.535-.536-.803-1.473-.803-.938 0-1.474.268-1.474.804 0 .402.402.535 1.474.535 1.875 0 2.678.536 2.678 1.608 0 1.205-.937 1.875-2.678 1.875-1.607 0-2.679-.67-2.679-1.742h1.072c0 .536.67.804 1.607.804.937 0 1.607-.268 1.607-.803zM9.375 13.393c0-.402-.536-.67-1.607-.67-1.741 0-2.545-.536-2.545-1.607s.938-1.741 2.545-1.741 2.678.67 2.678 1.741H9.241c0-.536-.536-.803-1.473-.803-.938.133-1.473.401-1.473.803s.401.536 1.473.536c1.875 0 2.678.536 2.678 1.607 0 1.205-.937 1.875-2.678 1.875-1.607 0-2.679-.67-2.679-1.741h1.072c0 .536.67.803 1.607.803 1.071 0 1.607-.267 1.607-.803zM25.848 13.929c-.134.133-.402-.134-.268-.268 0-.134.268-.536.536-1.072 1.205-2.41 1.607-5.089 1.072-7.768v-.267c0-.134.267-.402.267-.268.804.937 2.277 3.348 2.277 3.348.536.803.402 2.009-.268 2.678l-3.616 3.617zM3.75 12.723c.134.134-.134.402-.268.268-.536-.134-2.009-2.009-3.08-3.214-.536-.67-.536-1.741-.134-2.41C1.339 6.026 2.812 3.883 3.08 3.75c.134-.134.402 0 .268.268v.134c-.803 2.812-.67 5.893.402 8.571zM12.991 13.393v1.875h4.554v1.071h-5.76V9.51h5.626v1.071h-4.42v1.875h4.554v.938H12.99zM10.714 4.955v2.277h4.554v1.072H9.643V.67h4.42V1.74h-3.349v2.277h4.554v1.071h-4.554v-.134zM14.732.67h5.625V1.74H18.08V8.17H17.01V1.74h-2.277V.67z" />
        </g>
      </svg>
    </a>
    <div>
      <a href="/about#sponsors" class="link">Sponsor</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped>
.header {
  top: 0;
  width: 100%;
  text-align: center;
  position: fixed;

  margin-top: 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.header>* {
  flex: 1 auto;
  max-width: 100px;
}

.logo {
  opacity: 0.7;
  transition: opacity 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  display: flex;
  justify-content: center;
}

.logo:hover {
  opacity: 1;
}

.logo svg {
  height: 36px;
  color: var(--text);
}

.link {
  color: var(--text);
  opacity: 0.5;
  transition: all 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  font-weight: 500;
  border-bottom: 1px dashed var(--text);
  text-decoration: none;
}

.link:hover {
  opacity: 1;
  font-weight: 700;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue